import React from 'react';
import { HiArrowNarrowRight } from 'react-icons/hi';
import { Button, Link } from 'react-scroll';
import img from '../assets/pp.png'
const Home = () => {
  return (
    <div name='home' className='w-full h-screen bg-[#0a192f]'>
      {/* Container */}
      {/* <div className='max-w-[1000px] mx-auto px-8 flex flex-col justify-center h-full'>
        <p className='text-pink-600'>Hi, my name is</p>
        <h1 className='text-4xl sm:text-7xl font-bold text-[#ccd6f6]'>
          SAI KUMAR
        </h1>
        <h2 className='text-4xl sm:text-7xl font-bold text-[#8892b0]'>
          I'm a Full Stack Developer.
        </h2>
        <p className='text-[#8892b0] py-4 max-w-[700px]'>
          I’m a full-stack developer specializing in building (and occasionally
          designing) exceptional digital experiences. Currently, I’m focused on
          building responsive full-stack web applications.
        </p>
        <div>
          <button className='text-white group border-2 px-6 py-3 my-2 flex items-center hover:bg-pink-600 hover:border-pink-600'>
            View Work
            <span className='group-hover:rotate-90 duration-300'>
              <HiArrowNarrowRight className='ml-3 ' />
            </span>
          </button>
        </div>
      </div> */}
       <div
      name="home"
      className="h-screen w-full bg-[#0a192f]'"
    >
      <div className="max-w-screen-lg mx-auto flex flex-col items-center justify-center h-full px-4 md:flex-row">
       

        <div>
          <img
            src={img}
            alt="my profile"
           className='lg:h-1/2 lg:w-1/2 mt-20 w-3/5'
          />
        </div>
        <div className="flex flex-col justify-center h-full">
        <p className='text-pink-600'>Hi, my name is</p>
        <h1 className='text-xl sm:text-5xl font-bold text-[#ccd6f6]'>
          Khairul Islam Shaon
        </h1>
        <h2 className='text-xl sm:text-3xl font-bold text-[#8892b0]'>
          I'm a Full Stack Developer.
        </h2>
          <p className="text-gray-500 py-4 ">
          I’m a full-stack developer specializing in building (and occasionally
          designing) exceptional digital experiences. Currently, I’m focused on
          building responsive full-stack web applications.
          </p>

          <div>
            <button
             
             
              duration={500}
              className="group text-white font-bold w-fit px-6 py-3 my-2 flex items-center rounded-md bg-gradient-to-r from-cyan-500 to-blue-500  cursor-pointer"
            >
           <a href="https://docs.google.com/document/d/1Dx_VmJf16eqdONuwIWuoyVIDijAemRsq/edit?usp=sharing&ouid=116532682981174342246&rtpof=true&sd=true">  My Resume
          </a>
            </button>
          </div>
        </div>
      </div>
    </div>
    </div>
  );
};

export default Home;
